export const tickerItems: string[] = [
  "头部主播售后风波升级，退款流程仍卡在「人工审核」",
  "某连锁咖啡「喝出异物」事件两度反转，门店暂未公开质检",
  "顶流综艺剪辑被指与正片对不上，评论区已吵成一锅粥",
  "网红复出首播遭「价格刺客」质疑，选品清单被逐条扒",
  "电竞战队深夜官宣，多名核心成员去向成谜",
  "教培机构卷款消息刷屏，续费家长开始拉群维权",
];

export interface HotItem {
  rank: string;
  title: string;
  heat: string;
  tag: string;
  delta: string;
}

export const hotBoard: HotItem[] = [
  { rank: "01", title: "头部主播售后风波升级，退货潮仍在蔓延", heat: "986.4万", tag: "带货翻车", delta: "+2.1万" },
  { rank: "02", title: "连锁咖啡「喝出异物」事件两度反转", heat: "921.7万", tag: "品牌风波", delta: "+5.8万" },
  { rank: "03", title: "顶流综艺剪辑争议，正片与花絮对不上", heat: "884.2万", tag: "剪辑争议", delta: "-0.6万" },
  { rank: "04", title: "网红鼻祖复出首播，被扒同款高溢价", heat: "857.1万", tag: "价格刺客", delta: "+9.4万" },
  { rank: "05", title: "电竞战队深夜官宣，核心成员去向成谜", heat: "793.8万", tag: "体育电竞", delta: "+3.3万" },
  { rank: "06", title: "教培机构跑路前仍在收续费，家长组队维权", heat: "748.5万", tag: "商业失信", delta: "+1.7万" },
];

export interface NewsItem {
  title: string;
  summary: string;
  time: string;
  area: string;
  replies: string;
}

export const latestNews: NewsItem[] = [
  { title: "售后退款玩「文字游戏」，客服话术被录音曝光", summary: "消费者晒出全程沟通记录，退款时效一变再变，平台介入后仍未给出明确节点。", time: "18分钟前", area: "消费", replies: "1.2k" },
  { title: "把旧款当「首发」卖，宣传物料实锤日期对不上", summary: "对比早期海报与上架批次，网友质疑用旧库存冲新销量，官方暂未回应。", time: "42分钟前", area: "品牌", replies: "986" },
  { title: "综艺修音翻车现场流出，评委表情管理失败", summary: "无修音片段在社区流传，剪辑组紧急替换镜头，弹幕一片哗然。", time: "1小时前", area: "综艺", replies: "2.4k" },
  { title: "头部主播「最低价」被同平台百亿补贴打脸", summary: "同一链接两种到手价，粉丝直呼被割，补贴规则被扒出多条潜台词。", time: "2小时前", area: "带货", replies: "3.1k" },
  { title: "代言人刚官宣就翻车，品牌方连夜切割声明", summary: "历史争议旧帖被考古，品牌火速删博并更换宣传页头图，速度令人咋舌。", time: "3小时前", area: "代言", replies: "1.9k" },
  { title: "线下门店被指「只收钱不发货」，加盟商集体投诉", summary: "多城市门店同时关停，总部客服失联，加盟商晒出押金转账凭证。", time: "4小时前", area: "商业", replies: "860" },
  { title: "顶流背后「脂粉运营」疑云，群聊截图满天飞", summary: "所谓真爱粉群被指为职业水军，煽动对立节奏，组织者身份成谜。", time: "5小时前", area: "娱乐", replies: "4.7k" },
  { title: "赛事判罚争议冲上热搜，慢镜头回放被反复解读", summary: "关键一球改判引发双方粉丝互呛，官方深夜更新裁判报告。", time: "6小时前", area: "体育", replies: "2.8k" },
  { title: "直播预告「破价」最后却比别家贵，下单用户要求退差", summary: "百万观看的预告场次被录屏存档，退差诉求涌向客服后台。", time: "8小时前", area: "带货", replies: "1.5k" },
  { title: "App 弹窗收集通讯录被点名，隐私条款改前改后对比流出", summary: "更新前后对照截图被整理成图，用户担心数据被用于算法推荐。", time: "10小时前", area: "科技", replies: "2.2k" },
];

export const trendTags: string[] = [
  "带货翻车", "剪辑争议", "售后拖款", "价格刺客", "代言解约",
  "数据造假", "品牌撤单", "财报疑云", "口碑反转", "修音打假",
];

export interface Spotlight {
  area: string;
  kicker: string;
  title: string;
  summary: string;
  heat: string;
  tag: string;
  img: string;
  tone: "primary" | "accent" | "secondary";
}

export const spotlightItems: Spotlight[] = [
  {
    area: "舆情热议", kicker: "风向观察", title: "同一条旧瓜，为何三年后突然「二次发酵」",
    summary: "从营销号切片到路人考古，一场由算法和饭圈共同助推的热度回流，梳理它的完整路径。",
    heat: "612万", tag: "饭圈生态", tone: "primary",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20buzzing%20online%20community%20debate%2C%20layered%20speech%20bubbles%20and%20comment%20cards%20overlapping%20on%20warm%20cream%20and%20off-white%20paper%2C%20vermillion%20orange%20highlights%20with%20a%20small%20muted%20teal%20accent%2C%20textured%20paper%20grain%2C%20modern%20magazine%20collage%20style%2C%20abstract%20not%20photographic%2C%20high%20detail&width=800&height=520&seq=spot-community-x1&orientation=landscape",
  },
  {
    area: "品牌消费", kicker: "价格与话术", title: "「限时秒杀」到底谁说了算：直播间的定价迷宫",
    summary: "预告价、到手价、补贴价层层叠加，消费者到手前根本算不清，拆解这套话术的底层逻辑。",
    heat: "548万", tag: "价格刺客", tone: "secondary",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20price%20tags%20and%20discount%20labels%20in%20a%20row%2C%20warm%20cream%20and%20off-white%20paper%20background%2C%20vermillion%20orange%20and%20muted%20olive%20accents%2C%20minimal%20shopping%20cart%20silhouette%2C%20textured%20paper%2C%20modern%20magazine%20style%2C%20abstract%2C%20high%20detail&width=800&height=520&seq=spot-price-x2&orientation=landscape",
  },
  {
    area: "带货主播", kicker: "人设与转化", title: "「为家人谋福利」的另一面：售后该由谁兜底",
    summary: "流量红利期高喊底价，售后问题集中爆发期却集体沉默，主播与商家责任边界模糊。",
    heat: "887万", tag: "带货翻车", tone: "primary",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20smartphone%20with%20live%20shopping%20feed%20and%20comment%20stream%2C%20warm%20cream%20and%20off-white%20background%2C%20vermillion%20orange%20and%20soft%20teal%20accents%2C%20minimal%20microphone%20and%20cart%20icons%2C%20textured%20paper%2C%20modern%20magazine%20style%2C%20abstract%2C%20high%20detail&width=800&height=520&seq=spot-live-x3&orientation=landscape",
  },
  {
    area: "商业财经", kicker: "财报与承诺", title: "「长期主义」口号下，悄然变味的会员权益",
    summary: "条款细则逐字修订，优惠缩水却无人主动告知，扒一扒那些藏在末尾页的小字。",
    heat: "433万", tag: "会员缩水", tone: "accent",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20stacked%20documents%20and%20fine%20print%20contracts%20with%20magnifying%20glass%2C%20warm%20cream%20and%20off-white%20paper%2C%20muted%20teal%20and%20vermillion%20orange%20accents%2C%20minimal%20balance%20scale%20silhouette%2C%20textured%20paper%2C%20modern%20magazine%20style%2C%20abstract%2C%20high%20detail&width=800&height=520&seq=spot-finance-x4&orientation=landscape",
  },
  {
    area: "体育电竞", kicker: "判罚与舆论", title: "一次改判背后的 48 小时：从慢镜头到口水战",
    summary: "官方回放、粉丝剪辑、营销号切片三方混战，还原一场争议判罚的传播链条。",
    heat: "502万", tag: "判罚争议", tone: "secondary",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20whistle%20and%20floodlight%20over%20an%20abstract%20arena%2C%20warm%20cream%20and%20off-white%20paper%2C%20vermillion%20orange%20with%20muted%20olive%20accents%2C%20minimal%20geometric%2C%20textured%20paper%2C%20modern%20magazine%20style%2C%20abstract%2C%20high%20detail&width=800&height=520&seq=spot-sport-x5&orientation=landscape",
  },
  {
    area: "科技隐私", kicker: "条款与权限", title: "应用偷偷索权：那些你点过「允许」的隐私代价",
    summary: "通讯录、定位、剪贴板权限背后的真实用途，用一张图说清灰色边界在哪里。",
    heat: "398万", tag: "隐私合规", tone: "accent",
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20shield%20and%20data%20permission%20toggles%20on%20a%20phone%20screen%2C%20warm%20cream%20and%20off-white%20paper%2C%20muted%20teal%20and%20vermillion%20orange%20accents%2C%20minimal%20privacy%20icons%2C%20textured%20paper%2C%20modern%20magazine%20style%2C%20abstract%2C%20high%20detail&width=800&height=520&seq=spot-privacy-x6&orientation=landscape",
  },
];

export interface TimelineStep {
  date: string;
  title: string;
  desc: string;
  state: "爆料" | "扩散" | "回应" | "沉淀";
}

export const eventTimeline: TimelineStep[] = [
  { date: "08/28", title: "首发爆料帖出现", desc: "一张模糊截图在某讨论版首发，随后被营销号搬运，获赞数快速破万。", state: "爆料" },
  { date: "08/29", title: "多方证据开始汇合", desc: "下单记录、聊天截图、同城定位陆续被网友补充，形成「实锤」链条。", state: "扩散" },
  { date: "08/31", title: "官方发布说明", desc: "品牌方凌晨发声明，措辞被逐字解读，舆情并未因此降温。", state: "回应" },
  { date: "09/03", title: "跟进处理与反思帖", desc: "退款通道重开，评论区由「倒苦水」转向复盘事件来龙去脉。", state: "沉淀" },
];

export interface FieldEntry {
  title: string;
  level: number;
  time: string;
}

export interface FieldGroup {
  name: string;
  icon: string;
  desc: string;
  entries: FieldEntry[];
}

export const fieldGroups: FieldGroup[] = [
  {
    name: "综艺与影视", icon: "ri-clapperboard-line", desc: "剪辑、番位、剧本与修音争议",
    entries: [
      { title: "顶流综艺修音翻车现场", level: 9, time: "48分钟前" },
      { title: "番位海报被改，演员方下场表态", level: 8, time: "2小时前" },
      { title: "真人秀剧本痕迹遭网友逐帧复盘", level: 7, time: "5小时前" },
      { title: "导演专访言论被断章取义", level: 5, time: "11小时前" },
    ],
  },
  {
    name: "网红与带货", icon: "ri-shopping-bag-3-line", desc: "翻车、价格与虚假宣传盘点",
    entries: [
      { title: "头部主播最低价被补贴打脸", level: 10, time: "18分钟前" },
      { title: "复出首播同款高溢价引热议", level: 9, time: "1小时前" },
      { title: "切片矩阵号批量「碰瓷」素人", level: 6, time: "4小时前" },
      { title: "三无化妆品假一赔十被拒", level: 7, time: "9小时前" },
    ],
  },
  {
    name: "品牌与消费", icon: "ri-price-tag-3-line", desc: "定价、售后与会员权益变迁",
    entries: [
      { title: "连锁咖啡异物事件两度反转", level: 9, time: "40分钟前" },
      { title: "会员优惠细则悄然缩水", level: 7, time: "3小时前" },
      { title: "「限时秒杀」话术再被点名", level: 8, time: "6小时前" },
      { title: "联名周边黄牛囤货又毁单", level: 5, time: "12小时前" },
    ],
  },
  {
    name: "商业与财经", icon: "ri-line-chart-line", desc: "跑路、失信与融资疑云",
    entries: [
      { title: "教培机构卷款跑路前仍在收费", level: 9, time: "1小时前" },
      { title: "明星代言理财平台爆雷清算", level: 7, time: "8小时前" },
      { title: "新消费品牌烧钱换量的财报谜团", level: 6, time: "15小时前" },
      { title: "加盟商集体投诉总部失联", level: 8, time: "2小时前" },
    ],
  },
  {
    name: "体育与电竞", icon: "ri-trophy-line", desc: "判罚、转会与粉丝互撕",
    entries: [
      { title: "关键改判引发两派口水战", level: 8, time: "3小时前" },
      { title: "电竞战队深夜官宣阵容地震", level: 9, time: "50分钟前" },
      { title: "外援薪资被曝「阴阳合同」", level: 6, time: "10小时前" },
      { title: "联赛判罚尺度双标引热议", level: 5, time: "16小时前" },
    ],
  },
  {
    name: "饭圈与生态", icon: "ri-heart-2-line", desc: "控评、水军与对立节奏",
    entries: [
      { title: "脂粉运营群聊截图流出", level: 8, time: "2小时前" },
      { title: "控评机器人与路人开战", level: 7, time: "7小时前" },
      { title: "数据注水榜单被公开", level: 6, time: "13小时前" },
      { title: "同款旧瓜三年后二次发酵", level: 9, time: "4小时前" },
    ],
  },
];

export interface Thread {
  author: string;
  avatarTone: "primary" | "accent" | "secondary";
  time: string;
  tag: string;
  title: string;
  excerpt: string;
  replies: string;
  likes: string;
  hot: boolean;
}

export const hotThreads: Thread[] = [
  {
    author: "瓜田里的猹", avatarTone: "primary", time: "32分钟前", tag: "带货",
    title: "同款链接到手价两种？我两条号都下了，晒实付对比",
    excerpt: "大号带券 159，小号白板 129，差价 30 块连客服都说不清规则。录屏已存。",
    replies: "1.4k", likes: "8.6k", hot: true,
  },
  {
    author: "吃瓜不吐籽", avatarTone: "accent", time: "1小时前", tag: "综艺",
    title: "把修音版和泄露原声剪到一起，反差大到离谱",
    excerpt: "评委表情根本没变，全靠后期把音准拉回来，这钱也太好赚了。",
    replies: "2.9k", likes: "15.2k", hot: true,
  },
  {
    author: "数据考据党", avatarTone: "secondary", time: "2小时前", tag: "商业",
    title: "「长期主义」会员，我翻出三版条款对比",
    excerpt: "权益从 8 项砍到 5 项，期间没收到任何站内信。建议大家存好旧版截图。",
    replies: "980", likes: "6.3k", hot: false,
  },
  {
    author: "夜宵看台", avatarTone: "secondary", time: "3小时前", tag: "体育",
    title: "改判那个球，我慢放了二十遍还是觉得该吹",
    excerpt: "别急着站队，先把规则原文贴出来，咱们一条条对。",
    replies: "760", likes: "3.1k", hot: false,
  },
  {
    author: "反内卷先锋", avatarTone: "primary", time: "5小时前", tag: "科技",
    title: "App 更新后开始读我通讯录，抓包记录全在这",
    excerpt: "权限说明写得含糊，实际传输列表里却躺着联系人哈希值。",
    replies: "3.2k", likes: "21.7k", hot: true,
  },
];

export interface StatCard {
  label: string;
  value: string;
  unit: string;
}

export const communityStats: StatCard[] = [
  { label: "今日新增跟帖", value: "12.4", unit: "万" },
  { label: "社区活跃用户", value: "38.6", unit: "万" },
  { label: "话题归档", value: "920", unit: "+组" },
];

export const footerAbout =
  "51嘿料是一个围绕「不良记录与争议事件」的讨论与信息总集站，按主题整理近期负面清单与爆料脉络，帮助快速定位热门话题风向。站内内容为话题汇总与观点整理，不代表平台立场。";

export const footerCols: { title: string; links: string[] }[] = [
  { title: "栏目索引", links: ["热议榜", "综艺与影视", "网红与带货", "品牌与消费", "体育与电竞"] },
  { title: "总集归档", links: ["本周负面清单", "争议事件时间线", "判罚与回应记录", "评论区风向报告"] },
  { title: "关于本站", links: ["站内公告", "收录与纠错", "内容规范", "联系管理员"] },
];

export const noticeItems: string[] = [
  "站内信息来自公开讨论与多方整理，观点不代表平台立场",
  "收录前请先对照「收录与纠错」规范，避免引用未经证实的截图",
  "评论区言论由用户自行发布，请理性表达、就事论事",
];